import {cx} from "@emotion/css";

import infoIcon from "@/app/pages/upik/resources/info.svg";
import {isNotUndefined} from "@/shared/FunctionCore";
import {classCombinerFromPrefix} from "@/app/pages/upik/resources/RenderIdentifier";
import {privateMessageContent} from "@/app/pages/upik/resources/content";
import {PrivateMsgProps} from "@/app/pages/upik/resources/interfacesData";
import SearchTabsStyles from "@/app/pages/upik/styles/SearchTabsStyles.module.scss";
import React from "react";

const styles = SearchTabsStyles;
const classCombiner = classCombinerFromPrefix("6e1124ea8c05f948");

export const PrivateMsgBox = ({
    privateMsgLocalized,
    privateMsgNoteLocalized
}: PrivateMsgProps): JSX.Element => (
    <div className={cx(classCombiner(styles, "msgBox"))}>
        <img
            alt="info icon"
            className={cx(classCombiner(styles, "msgBoxInfoIcon"))}
            src={`${infoIcon}`}
        />

        <p className={cx(classCombiner(styles, "msgPara"))}>
            <b>
                {isNotUndefined(privateMsgNoteLocalized) ? privateMsgNoteLocalized : privateMessageContent.en.note}

                :

                {" "}
            </b>

            {isNotUndefined(privateMsgLocalized) ? privateMsgLocalized : privateMessageContent.en.text}
        </p>
    </div>
);
